import fetchPosts from "common/fetch/fetchPosts";
import fetchSeo from "common/fetch/fetchSeo";
import getStaticData from "common/fetch/getStaticData";

import Layout from "components/common/Layout";
import CorporateSecretary from "components/templates/sg/corporate-secretary";

import dataCompany from "./data";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="sg" page={data?.page}>
        <CorporateSecretary data={data} dataJson={dataCompany} />
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "sg";
  const uri = "/company-secretary";
  const page = await fetchSeo({
    uri,
    locale,
  });
  const data = await getStaticData({
    locale: "sg",
    uri: "/company-incorporation",
    data_package: {
      countryId: 191,
      websiteId: 2,
      subParam: "&package_group_id=2",

      queryStr: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/onboarding/services?country_id=191&website_id=2&package_group_id=2`,
    },
  });
  const posts = await fetchPosts({
    postPerPage: 20,
    gqlNode: `
    categories {
      nodes {
        name
        uri
        parent {
          node {
            id
          }
        }
      }
    }`,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts.nodes || [],
        packages: data,
      },
      revalidate: 1,
    },
  };
};
